import { Component, Input } from '@angular/core';
import { Muro } from '../../comun/models/muro.model';
import { MuroService } from '../../comun/services/muro.service';
import { GlobalConstants } from '../../global-constants';

@Component({
  selector: 'app-muro-perfil',
  templateUrl: './muro-perfil.component.html',
  styleUrl: './muro-perfil.component.css'
})
export class MuroPerfilComponent {
  @Input() misdatos!: any;
  @Input() perfil!: any;
  @Input() muro!: Muro;
  hoverIndex: number | null = null;
  hoverPrincipal = false;

  constructor(private muroService: MuroService) { }

  getMascotasLimitadas(mascotas: any[], limite: number = 1) {
    if (!mascotas)
      return [];
    return mascotas.slice(0, limite);
  }

  goPerfil(slug: string) {
    window.open(GlobalConstants.urlServer + 'perfil/' + slug, '_blank', 'noopener,noreferrer');
  }

}
